<template>
  <div id="search-input" class="input-group mb-15">
    <span class="input-group-btn">
      <button @click="handleInput" type="button" class="btn btn-default">
        <i class="fa fa-search"></i>
      </button>
    </span>
    <input
      :disabled="disabled"
      type="text"
      class="form-control"
      :placeholder="placeholder"
      v-model="content"
    >
  </div>
</template>

<script>
export default {
  name: 'SearchInput',
  props: {
    placeholder: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  components: {},
  data() {
    return {
      content: this.value,
    };
  },
  created() {
    document.addEventListener('keyup', (event) => {
      if (event.key === 'Enter') {
        this.$emit('input', this.content);
      }
    }, false);
  },
  computed: {},
  mounted() {},
  methods: {
    handleInput(e) {
      this.$emit('input', this.content);
    },
  },
};
</script>

<style lang="scss">
#search-input {
  input {text-transform: none;}
  input::-webkit-input-placeholder {text-transform: none;}
  input::-moz-placeholder {text-transform: none;}
}
</style>



// WEBPACK FOOTER //
// src/components/shared/inputs/SearchInput.vue